import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { CustomerRightNav } from "../Nav/CustomerRightNav";
import { Box, Dialog, DialogContent, LinearProgress, Tooltip } from "@mui/material";
import { useNavigate, useParams } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { InboxNotificationBell } from '../Icons/InboxNotificationBell';
import { IconButton } from '@mui/material';
import useAuth from "../../context/AuthProvider";
import Swal from "sweetalert2";
import Notification from "./Notification";
import { CustomerHomeRightNav } from "../Nav/CustomerHomeRightNav";
import { AppRoutes } from "../../helper/appRoutes";
import { NotificationPreferencesForm } from "../Elements/NotificationPreferencesForm";
import { FiUser } from "react-icons/fi";
import MenuIcon from '@mui/icons-material/Menu';
import { isClientHomeRole } from "../../helper/userRoles";
import { VscHome } from "react-icons/vsc";
import { EmailSettingsIcon } from "../Icons/EmailSettingsIcon";

export const GoBackIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);


export default function CustomerLayout() {
  const [showRightNav, setShowRightNav] = useState(true);
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  }
  const [loading, setloading] = useState(false);
  // const [notificationPopupOpen, setNotificationPopupOpen] = useState(false);
  const toggleRightNav = () => {
    setShowRightNav(!showRightNav);
  };
  const handleLogout = () => {
    Swal.fire({
        title: 'Log Out',
        text: "Are you sure you want to log out?",
        showCancelButton: true,
        confirmButtonColor: '#02A4E3',
        cancelButtonColor: '#d33',
        customClass: 'logout-popup',
        // iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        iconHtml: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-power" viewBox="0 0 16 16"> \
                    <path d="M7.5 1v7h1V1z"/> \
                    <path d="M3 8.812a5 5 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812"/> \
                  </svg>',
    }).then((result) => {
      if (result.isConfirmed) {
        logOut();
        navigate(AppRoutes.login); 
        return;
      }
    })
  };
  const { user, logout } = useAuth();
  const logOut = () => {
    logout();
  };
  const homeRoute = isClientHomeRole(user?.userRoles)
    ? AppRoutes.client.home
    : AppRoutes.home.base;
 
  return (
    <main>
      <section className="policy-dashboard-section">
        <div className={`banner-section ${!showRightNav ? 'right-nav-open' : ''}`}>
          <div className="img-bg-sec">
            <div className="right-nav-popup">
              <div className="nav-section">
                <nav className="navbar navbar-expand-lg navbar-light ">
                  <div className="w-100 d-flex align-items-center justify-content-between">
                    <a className="navbar-brand main-img nav-left me-0" style={{ flex: '0 0 auto' }} href={homeRoute}>
                      <img src=" /assets/brand/MISC_Full_Type_Lockup_Primary.png" alt="" />
                    </a>

                    <div className="d-flex align-items-center container-fluid pe-0" id="navbarTogglerDemo01">
                      <ul className="d-flex align-items-center mb-0 ps-0" style={{ marginLeft: 'auto' }}>
                        <li className="nav-item tag py-0">
                          <IconButton
                            size="medium"
                            sx={{
                              color: 'white',
                              verticalAlign: 'middle',
                              '&:hover': {
                                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                              },
                            }}
                            onClick={() => navigate(homeRoute)}
                          >
                            <VscHome size={26} color="currentColor" />
                          </IconButton>
                        </li>
                        <li className="nav-item back tag py-0">
                          <div title="Go Back" onClick={goBack}
                            style={{ cursor: "pointer" }}
                          >
                            <IconButton
                              // onClick={toggleRightNav}
                              size="medium"
                              sx={{
                                color: 'white',
                                '&:hover': {
                                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                },
                              }}
                            >
                              <GoBackIcon />
                            </IconButton>
                          </div>
                        </li>
                        <li className="nav-item d-none d-md-block tag py-0" style={{ display: 'flex', alignItems: 'center' }}>
                          <InboxNotificationBell variant="white" title="Inbox" />
                        </li>
                        {/* <li className="nav-item d-none d-md-block tag py-0">
                          <div
                            title="Email notification settings"
                            onClick={() => setNotificationPopupOpen(true)}
                            style={{ cursor: "pointer", display: "flex", alignItems: "center", color: "white" }}
                          >
                            <IconButton
                              // onClick={toggleRightNav}
                              size="medium"
                              sx={{
                                color: 'white',
                                '&:hover': {
                                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                },
                              }}
                            >
                            <EmailSettingsIcon fontSize={24} variant="white" />
                            </IconButton>
                          </div>
                        </li> */}
                        {!user?.userRoles?.split(",").includes("Customer Processors") &&
                         !user?.userRoles?.split(",").includes("Customer Operations")&& (
                        <li className="nav-item menu tag py-0">
                          <div
                            style={{ cursor: "pointer" }}
                            // onClick={toggleRightNav}
                          >
                            <IconButton
                              onClick={toggleRightNav}
                              size="medium"
                              sx={{
                                color: 'white',
                                '&:hover': {
                                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                },
                              }}
                            >
                              <MenuIcon sx={{ fontSize: 24 }} />
                            </IconButton>
                          </div>
                        </li>
                        )}
                        <li className="nav-item line">
                          <svg
                            width="1"
                            height="31"
                            viewBox="0 0 1 31"
                            fill="none"
                            className="white"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <line
                              x1="0.5"
                              y1="2.18557e-08"
                              x2="0.499999"
                              y2="31"
                              stroke="white"
                            />
                          </svg>
                        </li>
                        <li className="nav-item user d-none d-md-block tag py-0" title={user?.userFirstName ?? ''}>
                          <div className="d-flex align-items-center text-white">
                            <strong className="me-2 d-inline-flex flex-column align-items-end lh-1">
                              <span className="text-white">{user?.userFirstName}</span>
                              <small className="text-white-50">{user?.userRoles.split(",")[0]}</small>
                            </strong>
                            <Tooltip title="Account / Log out">
                              <IconButton
                                onClick={handleLogout}
                                size="medium"
                                sx={{
                                  color: 'grey.800',
                                  '&:hover': {
                                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                  },
                                }}
                              >
                                  <FiUser size={26} color="#FFF" />
                                </IconButton>
                            </Tooltip>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </nav>

              </div>

            </div>
          </div>
          
        </div>
        <CustomerHomeRightNav Open={showRightNav} handleClose={toggleRightNav} />
        <Box
          className="demo-2"
          sx={{
            // backgroundColor: "#ffffff",
            // height: "100%",
          }}
        >
          <Box
            className="layout-padding"
            sx={{
              // height: "100%",
              display: "flex",
              flexDirection: "column",
              transform: showRightNav ? 'translateX(0)' : 'translateX(-358px)',
              transition: 'all 0.3s ease',
            }}
          >
            <Outlet />
          </Box>
        </Box>
      </section>
    </main >
  );
}
